export function createGeminiLivePlaybackQueue(getAudioContext) {
  let playheadTime = 0;
  const sources = new Set();

  function enqueue(buffer) {
    const audioContext = getAudioContext?.();
    if (!audioContext) return;

    const source = audioContext.createBufferSource();
    source.buffer = buffer;
    source.connect(audioContext.destination);
    source.onended = () => sources.delete(source);

    const startTime = Math.max(playheadTime, audioContext.currentTime);
    sources.add(source);
    source.start(startTime);
    playheadTime = startTime + buffer.duration;
  }

  function interrupt() {
    const audioContext = getAudioContext?.();
    const activeSources = [...sources];
    sources.clear();
    playheadTime = audioContext?.currentTime || 0;

    activeSources.forEach((source) => {
      try {
        source.stop();
      } catch {
        // The source may have ended between the snapshot and stop().
      }
    });
  }

  return { enqueue, interrupt };
}
